export class Turma {
  constructor({
    id = null,
    nome = null,
    anoLetivo = null,
    serie = null,
    turno = null,
    municipio = null,
    escola = null,
    professorPortugues = null,
    professorMatematica = null,
    quantidadeAlunos = null,
  }) {
    this.id = id;
    this.nome = nome;
    this.serie = serie;
    this.anoLetivo = anoLetivo;
    this.escola = escola?.id == null? escola: escola?.id ;
    this.turno = turno;
    this.municipio = municipio?.id == null? municipio: municipio?.id;
    this.professorMatematica = professorMatematica,
    this.professorPortugues = professorPortugues,
    this.quantidadeAlunos = quantidadeAlunos != null ? parseInt(quantidadeAlunos) : null;
  }
  static Build() {
    return new Turma({
      id: null,
      nome: null,
      anoLetivo: null,
      serie: null,
      escola: null,
      turno: null,
      municipio: null,
      professorMatematica: null,
      professorPortugues: null,
      quantidadeAlunos: null,
    });
  }
  format() {
    return this;
  }
}
